(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_before-after-carousel-content"] && !Shopify.designMode) return;
  try {
    (() => {
    const DESKTOP_MEDIA_QUERY = '(min-width: 750px)';

    // Slides here are plain comparison-slider-component children (not
    // slideshow-slide elements with ref="slides[]"), so the native
    // Slideshow class has nothing registered to select() between - button
    // clicks scroll the container directly instead. Scroll-snap is
    // disabled only for the duration of the smooth scroll so it doesn't
    // fight the animation and cause it to cut short, then restored once
    // scrolling settles (scrollend, with a timeout fallback for browsers
    // that don't support it). This is the same snap-safe smooth-scroll
    // pattern the Reviews carousel gets from its Scroller class.
    function animateScrollLeft(scroller, left) {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scroller.style.scrollSnapType = 'none';

      const restoreSnap = () => {
        scroller.style.scrollSnapType = '';
      };

      if ('onscrollend' in window) {
        scroller.addEventListener('scrollend', restoreSnap, { once: true });
      } else {
        setTimeout(restoreSnap, 700);
      }

      scroller.scrollTo({ left, behavior: prefersReducedMotion ? 'instant' : 'smooth' });
    }

    // Distance (in px) from the scroller's left edge to a child's left edge,
    // measured from actual rendered layout rather than derived from the gap/
    // width CSS custom properties - stays correct regardless of rounding,
    // borders, or future style changes.
    function getRelativeLeft(scroller, child) {
      return child.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
    }

    // How many whole slides are visible at once, measured from the actual
    // gap between two consecutive slides' left edges (includes the gap),
    // not assumed from a columns setting.
    function getSlidesPerView(scroller, children) {
      if (children.length < 2) return 1;
      const step = getRelativeLeft(scroller, children[1]) - getRelativeLeft(scroller, children[0]);
      if (!step) return 1;
      return Math.max(1, Math.round(scroller.clientWidth / step));
    }

    // Index of the slide currently at (or nearest to) the scroller's left
    // edge - recomputed from real scroll position every time, so it can't
    // drift out of sync after a manual swipe/drag.
    function getCurrentIndex(scroller, children) {
      let closestIndex = 0;
      let closestDelta = Infinity;
      children.forEach((child, index) => {
        const delta = Math.abs(getRelativeLeft(scroller, child) - scroller.scrollLeft);
        if (delta < closestDelta) {
          closestDelta = delta;
          closestIndex = index;
        }
      });
      return closestIndex;
    }

    function updateDisabled(scroller, children, previous, next) {
      if (!window.matchMedia(DESKTOP_MEDIA_QUERY).matches) {
        const max = scroller.scrollWidth - scroller.clientWidth;
        previous.disabled = scroller.scrollLeft <= 1;
        next.disabled = scroller.scrollLeft >= max - 1;
        return;
      }

      const current = getCurrentIndex(scroller, children);
      const slidesPerView = getSlidesPerView(scroller, children);
      const maxIndex = Math.max(0, children.length - slidesPerView);
      previous.disabled = current <= 0;
      next.disabled = current >= maxIndex;
    }

    // Desktop: advance/retreat by exactly slidesPerView (2, by default),
    // snapping to the slide boundary so the pair is never cut off or
    // trailed by a stray gap. The final view clamps to
    // maxIndex = totalSlides - slidesPerView so it always shows a full,
    // valid pair - even if that means repeating the second-to-last slide -
    // instead of ever landing on the last slide alone.
    function navigateDesktop(scroller, children, direction, previous, next) {
      const current = getCurrentIndex(scroller, children);
      const slidesPerView = getSlidesPerView(scroller, children);
      const maxIndex = Math.max(0, children.length - slidesPerView);

      const targetIndex =
        direction === 'next'
          ? Math.min(current + slidesPerView, maxIndex)
          : Math.max(current - slidesPerView, 0);

      const target = children[targetIndex];
      if (!target) return;

      animateScrollLeft(scroller, getRelativeLeft(scroller, target));

      // Reflect the new position immediately rather than waiting for a
      // scroll event to fire (which may lag behind or, mid-animation,
      // report an in-between index).
      previous.disabled = targetIndex <= 0;
      next.disabled = targetIndex >= maxIndex;
    }

    // Mobile/tablet: unchanged from the original behaviour (page by one
    // viewport width) - the partial-peek layout there isn't a fixed-count
    // pair carousel, so it doesn't need index/pair snapping.
    function navigateMobile(scroller, direction) {
      const delta = direction === 'next' ? scroller.clientWidth : -scroller.clientWidth;
      animateScrollLeft(scroller, scroller.scrollLeft + delta);
    }

    function initCarouselNav(carousel) {
      // Use a DOM marker (not a JS closure flag) so init stays idempotent even if
      // this script is evaluated more than once (e.g. section reloads in the editor).
      if (carousel.dataset.bacNavInitialized) return;
      carousel.dataset.bacNavInitialized = 'true';

      const scroller = carousel.querySelector('slideshow-slides');
      const nav = carousel.querySelector('.before-after-carousel-content__nav');
      const previous = nav?.querySelector('.slideshow-control--previous');
      const next = nav?.querySelector('.slideshow-control--next');
      if (!scroller || !previous || !next) return;

      // Each comparison-slider block's own inline script renders as a
      // sibling <script> tag interleaved with its comparison-slider-
      // component element, so scroller.children isn't just the slides -
      // filter to elements that actually occupy layout space.
      const getChildren = () =>
        Array.from(scroller.children).filter((el) => el.offsetWidth > 0 || el.offsetHeight > 0);

      previous.addEventListener('click', (event) => {
        event.stopPropagation();
        const children = getChildren();
        if (window.matchMedia(DESKTOP_MEDIA_QUERY).matches) {
          navigateDesktop(scroller, children, 'previous', previous, next);
        } else {
          navigateMobile(scroller, 'previous');
        }
      });

      next.addEventListener('click', (event) => {
        event.stopPropagation();
        const children = getChildren();
        if (window.matchMedia(DESKTOP_MEDIA_QUERY).matches) {
          navigateDesktop(scroller, children, 'next', previous, next);
        } else {
          navigateMobile(scroller, 'next');
        }
      });

      scroller.addEventListener(
        'scroll',
        () => window.requestAnimationFrame(() => updateDisabled(scroller, getChildren(), previous, next)),
        { passive: true }
      );
      window.addEventListener(
        'resize',
        () => updateDisabled(scroller, getChildren(), previous, next),
        { passive: true }
      );

      updateDisabled(scroller, getChildren(), previous, next);
    }

    function initAll(root = document) {
      root.querySelectorAll('.before-after-carousel-content').forEach(initCarouselNav);
    }

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
